import COLORS from "scss/colors.module.scss";


let uniqueId = 1;
export const getUniqueId = () => {
    return "unique_" + uniqueId++;
}

export const sleep = async (milliSeconds = 1) => {
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            resolve();
        }, milliSeconds)
    });
}

export const lightenColor = (hex) => {
    hex = hex.replace(/^#/, '');
    if (hex.length === 3) {
        hex = hex.split('').map(c => c + c).join('');
    }
    if (hex.length !== 6) return '#ffffff';
    const r = parseInt(hex.slice(0, 2), 16);
    const g = parseInt(hex.slice(2, 4), 16);
    const b = parseInt(hex.slice(4, 6), 16);

    const brightness = 0.299 * r + 0.587 * g + 0.114 * b;
    let blendStrength;

    if (brightness <= 80) blendStrength = 90;
    else if (brightness > 80 && brightness <= 120) blendStrength = 90;
    else if (brightness > 120 && brightness <= 140) blendStrength = 85;
    else if (brightness > 140 && brightness <= 160) blendStrength = 85;
    else if (brightness > 160 && brightness <= 180) blendStrength = 85;
    else if (brightness > 180 && brightness <= 200) blendStrength = 80;
    else if (brightness > 200 && brightness <= 220) blendStrength = 70;
    else if (brightness > 220 && brightness <= 240) blendStrength = 50;
    else blendStrength = 0;

    const blend = (c) =>
        Math.round((255 - c) * (blendStrength / 100) + c);
    const rL = blend(r);
    const gL = blend(g);
    const bL = blend(b);
    const toHex = (val) => val.toString(16).padStart(2, '0');
    return `#${toHex(rL)}${toHex(gL)}${toHex(bL)}`;
}

export {
    formatDate,
    getFormat as getDateFormat,
    formatTime
} from "./dateFormatter"

export function getRandomColor() {
    const colors = COLORS.HEADER_BACKGROUNDS.split(",").map(color => color.trim());
    const i = Math.floor(Math.random() * colors.length);

    return colors[i];
}

window.Array.prototype.getRandomValue = function () {
    const i = Math.floor(Math.random() * this.length);
    return this[i];
}

let s;
String.prototype.ucfirst = function (notrim) {
    s = notrim ? this : this.replace(/(?:(?:^|\n)\s+|\s+(?:$|\n))/g, '').replace(/\s+/g, ' ');
    return s.length > 0 ? s.charAt(0).toUpperCase() + s.slice(1) : s;
}

//To convert string to camel case
String.prototype.camelCase = function () {
    return this.toLowerCase().replace(/ (.)/g, function (match, group1) {
        return group1.toUpperCase();
    });
};

// Ext.util.Format.br2nl = function (str) {
//     return str.replace(/<br\s*\/?>/mg, "\n");
// };

const Util = {};
Util.isJson = function (text) {
    /*if (/^[\],:{}\s]*$/.test(text.replace(/\\["\\\/bfnrtu]/g, '@').
     replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']').
     replace(/(?:^|:|,)(?:\s*\[)+/g, ''))) {

     return true;

     } else {

     return false;

     }*/

    try {
        if (isNaN(text)) {
            JSON.parse(text);
        } else {
            return false;
        }
    } catch (e) {
        return false;
    }
    return true;
}
Util.toCamelCase = function (s) {
    s = s || '';
    // remove all characters that should not be in a variable name
    // as well underscores an numbers from the beginning of the string
    s = s.replace(/([^a-zA-Z0-9_\- ])|^[_0-9]+/g, "").trim().toLowerCase();
    // uppercase letters preceeded by a hyphen or a space
    s = s.replace(/([ -]+)([a-zA-Z0-9])/g, function (a, b, c) {
        return c.toUpperCase();
    });
    // uppercase letters following numbers
    s = s.replace(/([0-9]+)([a-zA-Z])/g, function (a, b, c) {
        return b + c.toUpperCase();
    });
    return s;
}

Util.toUpperCamelCase = function (string) {
    string = Util.toCamelCase(string);
    return string.charAt(0).toUpperCase() + string.slice(1);
}

Util.getAngle = function (p1, p2) {
    return Math.atan((p2.y - p1.y) / (p2.x - p1.x))
}


Util.exportToExcel = function (base64Content, filename, appendTimestamp) {
    //creating a temporary HTML link element (they support setting file names)
    var a = document.createElement('a');

    filename = filename || "download.xls";
    appendTimestamp = appendTimestamp || false;

    if (appendTimestamp) {
        var dt = new Date();
        var day = dt.getDate();
        var month = dt.getMonth() + 1;
        var year = dt.getFullYear();
        var hour = dt.getHours();
        var mins = dt.getMinutes();

        filename += "-" + (day + "." + month + "." + year + "_" + hour + "." + mins);
    }

    a.href = "data:application/vnd.ms-excel;base64," + base64Content;
    //setting the file name
    a.download = filename + ".xls";
    //triggering the function
    a.click();
    //just in case, prevent default behaviour
    //e.preventDefault();
}

Util.handleAjaxError = function (ajaxResponse, isUpdate) {
    var responseData = Ext.JSON.decode(ajaxResponse.responseText),
        win = null,
        windowConfig = null;

    isUpdate = isUpdate || false;

    if (!responseData) // request timed out?
    {
        responseData = {
            ExceptionType: 'Timeout',
            message: 'It appears the request timed out, ' + (!isUpdate ? 'please try again. ' : 'please refresh the page (or click <a href="" target="_blank">here</a> to open in a new tab) to see if the request is successful. <br/><br/> If not, please try again. ')
        };
    }

    // Window to show
    windowConfig = {
        title: 'Error: ' + Ext.htmlEncode(responseData.ExceptionType),
        layout: 'anchor',
        defaults: { anchor: '100%' },
        modal: true,
        resizable: false,
        width: 400,
        items: [{
            xtype: 'container',
            autoScroll: true,
            html:
                /* '<img style="float: left; padding: 5px;" src="../extjs/resources/themes/images/gray/shared/icon-error.gif">'
                               +*/
                '<div style="padding: 10px;">' + responseData.message + '</div>'
        }], // eo items
        buttons: [{
            text: 'OK',
            handler: function () {
                win.destroy();
            }
        }], // eo buttons
        listeners: {
            afterrender: { // make sure layout sized properly
                single: true,
                buffer: 10,
                fn: function () {
                    return;
                    win.doLayout();
                }
            } // eo afterrender
        } // eo listeners
    };

    // Stack trace panel on the bottom?
    if (responseData.StackTrace) {
        windowConfig.items.push({
            xtype: 'panel',
            title: 'Stack Trace',
            collapsible: true,
            collapsed: true,
            titleCollapse: true,
            layout: 'fit',
            listeners: {
                collapse: function () {
                    win.doLayout();
                },
                expand: function () {
                    win.doLayout();
                }
            },
            items: {
                xtype: 'textarea',
                readOnly: true,
                height: 150,
                value: responseData.StackTrace
            }
        });
    }


    win = Ext.create('Ext.window.Window', windowConfig);
    win.show();
};

Util.formatCurrencyColumn = function (val, opts) {
    if (opts && opts.length > 0) {
        var decimals = typeof opts[0].decimals != "undefined" ? opts[0].decimals : 2,
            currencySymbol = typeof opts[0].currency_symbol != "undefined" ? opts[0].currency_symbol : "USD $",
            symbolAtEnd = typeof opts[0].symbol_at_end != "undefined" ? opts[0].symbol_at_end : false,
            numberFormat = opts[0].number_format || "100,000,000";

        return Util.formatCurrency(val, currencySymbol, decimals, symbolAtEnd, numberFormat);
    } else {
        return val;
    }
};

Util.formatCurrency = function (v, currencySign, decimals, end, numberFormat) {
    var negativeSign = '';

    v = v - 0;
    if (v < 0) {
        v = -v;
        negativeSign = '-';
    }
    decimals = Ext.isDefined(decimals) ? decimals : 0;

    v = this.formatNumber(Number(v).toFixed(decimals), numberFormat, decimals);
    if (end) {
        return Ext.String.format("{0}{1}{2}", negativeSign, v, currencySign);
    } else {
        return Ext.String.format("{0}{1}{2}", negativeSign, currencySign, v);
    }
}

Util.formatNumberColumn = function (val, opts) {
    if (opts && opts.length > 0) {
        var decimals = typeof opts[0].decimals != "undefined" ? opts[0].decimals : 2;
        //pow = Math.pow(10, decimals);
        if (typeof opts[0].number_format != "undefined") {
            return this.formatNumber(Number(val).toFixed(decimals), opts[0].number_format, decimals);
        } else {
            return Number(val).toFixed(decimals);
        }
    } else {
        return val;
    }

}

Util.formatNumber = function (number, format, decimal) {
    var res = [];

    number = number.toString();

    res = number.split(".");
    if (format == "10,00,000") {
        var lastThree = res[0].substring(res[0].length - 3),
            otherNumbers = res[0].substring(0, res[0].length - 3),
            indianFormatNumb = '';

        if (otherNumbers != '')
            lastThree = ',' + lastThree;
        indianFormatNumb = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
        return (typeof res[1] != 'undefined') ? indianFormatNumb + "." + res[1] : indianFormatNumb;
    } else if (format == "100,000,000") {
        var internationalFormatNumb = res[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

        return (typeof res[1] != 'undefined') ? internationalFormatNumb + "." + res[1] : internationalFormatNumb;
    } else {
        return number;
    }
}


Util.padWith = function (number, length, prefix, leftOrRight) {
    var myString = '' + number,
        prefix = prefix || '0',
        leftOrRight = leftOrRight || "LEFT";

    while (myString.length < length) {
        myString = (leftOrRight == 'LEFT') ? (prefix + myString) : (myString + prefix);
    }

    return myString;
};

Util.toBoolean = function (input) {
    if (typeof input !== 'string') {
        return Boolean(input);
    }
    const s = input.toLowerCase();
    return ['t', 'y', '1'].some(prefix => s.startsWith(prefix));
}

Util.getStringWidth = function (string) {
    var dom = $('<span style="white-space: nowrap"></span>').appendTo($(document.body)).html(string),
        width = dom.width();

    dom.remove();

    return width;
};

Util.getYoutubeEmbedUrl = function (url) {
    var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
    var match = url.match(regExp);

    if (match && match[2].length == 11) {
        return match[2];
    } else {
        return 'error';
    }
}

Util.removeLines = function (string) {
    return (string + "").replace(/(\r\n\t|\n|\r\t)/gm, "");
}


Util.downloadFile = function (config) {
    config = config || {};
    var url = config.url,
        method = config.method || 'POST', // Either GET or POST. Default is POST.
        params = config.params || {};

    // Create form panel. It contains a basic form that we need for the file download.
    var form = Ext.create('Ext.form.Panel', {
        standardSubmit: true,
        url: url,
        method: method
    });

    // Call the submit to begin the file download.
    form.submit({
        target: '_blank', // Avoids leaving the page.
        params: params
    });

    // Clean-up the form after 100 milliseconds.
    // Once the submit is called, the browser does not care anymore with the form object.
    Ext.defer(function () {
        form.close();
    }, 100);

};

Util.copyToClipboard = function (txt, message) {
    message = message || "Copied to clipboard";
    txt = document.createTextNode(txt);
    var m = document;
    var w = window;
    var b = m.body;
    b.appendChild(txt);
    if (b.createTextRange) {
        var d = b.createTextRange();
        d.moveToElementText(txt);
        d.select();
        m.execCommand('copy');
    } else {
        var d = m.createRange();
        var g = w.getSelection;
        d.selectNodeContents(txt);
        g().removeAllRanges();
        g().addRange(d);
        m.execCommand('copy');
        g().removeAllRanges();
    }
    txt.remove();

    webix.message({
        text: message,
        type: "success",
        expire: 3000
    });
    const toastNotification = document.querySelector(".webix_message_area");
    if (toastNotification)
    {
        toastNotification.style.zIndex = "100000";
    }
};

Util.selectText = function selectText(containerid) {
    if (document.selection) { // IE
        var range = document.body.createTextRange();
        range.moveToElementText(document.getElementById(containerid));
        range.select();
    } else if (window.getSelection) {
        var range = document.createRange();
        range.selectNode(document.getElementById(containerid));
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
    }
};


Util.getMaterialColor = function () {
    var pickRandomProperty = function (obj) {
        var result;
        var count = 0;
        for (var prop in obj)
            if (Math.random() < 1 / ++count)
                result = prop;
        return result;
    };
    // colors from https://github.com/egoist/color-lib/blob/master/color.json
    var colors = {
        "red": {
            // "50": "#ffebee",
            // "100": "#ffcdd2",
            "200": "#ef9a9a",
            "300": "#e57373",
            "400": "#ef5350",
            "500": "#f44336",
            "600": "#e53935",
            "700": "#d32f2f",
            "800": "#c62828",
            "900": "#b71c1c",
            "hex": "#f44336",
            "a100": "#ff8a80",
            "a200": "#ff5252",
            "a400": "#ff1744",
            "a700": "#d50000"
        },
        "pink": {
            // "50": "#fce4ec",
            // "100": "#f8bbd0",
            "200": "#f48fb1",
            "300": "#f06292",
            "400": "#ec407a",
            "500": "#e91e63",
            "600": "#d81b60",
            "700": "#c2185b",
            "800": "#ad1457",
            "900": "#880e4f",
            "hex": "#e91e63",
            "a100": "#ff80ab",
            "a200": "#ff4081",
            "a400": "#f50057",
            "a700": "#c51162"
        },
        "purple": {
            // "50": "#f3e5f5",
            // "100": "#e1bee7",
            "200": "#ce93d8",
            "300": "#ba68c8",
            "400": "#ab47bc",
            "500": "#9c27b0",
            "600": "#8e24aa",
            "700": "#7b1fa2",
            "800": "#6a1b9a",
            "900": "#4a148c",
            "hex": "#9c27b0",
            "a100": "#ea80fc",
            "a200": "#e040fb",
            "a400": "#d500f9",
            "a700": "#aa00ff"
        },
        "deepPurple": {
            // "50": "#ede7f6",
            // "100": "#d1c4e9",
            "200": "#b39ddb",
            "300": "#9575cd",
            "400": "#7e57c2",
            "500": "#673ab7",
            "600": "#5e35b1",
            "700": "#512da8",
            "800": "#4527a0",
            "900": "#311b92",
            "hex": "#673ab7",
            "a100": "#b388ff",
            "a200": "#7c4dff",
            "a400": "#651fff",
            "a700": "#6200ea"
        },
        "indigo": {
            // "50": "#e8eaf6",
            // "100": "#c5cae9",
            "200": "#9fa8da",
            "300": "#7986cb",
            "400": "#5c6bc0",
            "500": "#3f51b5",
            "600": "#3949ab",
            "700": "#303f9f",
            "800": "#283593",
            "900": "#1a237e",
            "hex": "#3f51b5",
            "a100": "#8c9eff",
            "a200": "#536dfe",
            "a400": "#3d5afe",
            "a700": "#304ffe"
        },
        "blue": {
            // "50": "#e3f2fd",
            // "100": "#bbdefb",
            "200": "#90caf9",
            "300": "#64b5f6",
            "400": "#42a5f5",
            "500": "#2196f3",
            "600": "#1e88e5",
            "700": "#1976d2",
            "800": "#1565c0",
            "900": "#0d47a1",
            "hex": "#2196f3",
            "a100": "#82b1ff",
            "a200": "#448aff",
            "a400": "#2979ff",
            "a700": "#2962ff"
        },
        "lightBlue": {
            // "50": "#e1f5fe",
            // "100": "#b3e5fc",
            "200": "#81d4fa",
            "300": "#4fc3f7",
            "400": "#29b6f6",
            "500": "#03a9f4",
            "600": "#039be5",
            "700": "#0288d1",
            "800": "#0277bd",
            "900": "#01579b",
            "hex": "#03a9f4",
            "a100": "#80d8ff",
            "a200": "#40c4ff",
            "a400": "#00b0ff",
            "a700": "#0091ea"
        },
        "cyan": {
            // "50": "#e0f7fa",
            // "100": "#b2ebf2",
            "200": "#80deea",
            "300": "#4dd0e1",
            "400": "#26c6da",
            "500": "#00bcd4",
            "600": "#00acc1",
            "700": "#0097a7",
            "800": "#00838f",
            "900": "#006064",
            "hex": "#00bcd4",
            "a100": "#84ffff",
            "a200": "#18ffff",
            "a400": "#00e5ff",
            "a700": "#00b8d4"
        },
        "teal": {
            // "50": "#e0f2f1",
            // "100": "#b2dfdb",
            "200": "#80cbc4",
            "300": "#4db6ac",
            "400": "#26a69a",
            "500": "#009688",
            "600": "#00897b",
            "700": "#00796b",
            "800": "#00695c",
            "900": "#004d40",
            "hex": "#009688",
            // "a100": "#a7ffeb",
            "a200": "#64ffda",
            "a400": "#1de9b6",
            "a700": "#00bfa5"
        },
        "green": {
            // "50": "#e8f5e9",
            // "100": "#c8e6c9",
            "200": "#a5d6a7",
            "300": "#81c784",
            "400": "#66bb6a",
            "500": "#4caf50",
            "600": "#43a047",
            "700": "#388e3c",
            "800": "#2e7d32",
            "900": "#1b5e20",
            "hex": "#4caf50",
            // "a100": "#b9f6ca",
            "a200": "#69f0ae",
            "a400": "#00e676",
            "a700": "#00c853"
        },
        "lightGreen": {
            // "50": "#f1f8e9",
            // "100": "#dcedc8",
            // "200": "#c5e1a5",
            "300": "#aed581",
            "400": "#9ccc65",
            "500": "#8bc34a",
            "600": "#7cb342",
            "700": "#689f38",
            "800": "#558b2f",
            "900": "#33691e",
            "hex": "#8bc34a",
            // "a100": "#ccff90",
            "a200": "#b2ff59",
            "a400": "#76ff03",
            "a700": "#64dd17"
        },
        "lime": {
            // "50": "#f9fbe7",
            // "100": "#f0f4c3",
            // "200": "#e6ee9c",
            "300": "#dce775",
            "400": "#d4e157",
            "500": "#cddc39",
            "600": "#c0ca33",
            "700": "#afb42b",
            "800": "#9e9d24",
            "900": "#827717",
            "hex": "#cddc39",
            "a100": "#f4ff81",
            "a200": "#eeff41",
            "a400": "#c6ff00",
            "a700": "#aeea00"
        },
        "yellow": {
            // "50": "#fffde7",
            // "100": "#fff9c4",
            "200": "#fff59d",
            "300": "#fff176",
            "400": "#ffee58",
            "500": "#ffeb3b",
            "600": "#fdd835",
            "700": "#fbc02d",
            "800": "#f9a825",
            "900": "#f57f17",
            "hex": "#ffeb3b",
            // "a100": "#ffff8d",
            "a200": "#ffff00",
            "a400": "#ffea00",
            "a700": "#ffd600"
        },
        "amber": {
            // "50": "#fff8e1",
            // "100": "#ffecb3",
            "200": "#ffe082",
            "300": "#ffd54f",
            "400": "#ffca28",
            "500": "#ffc107",
            "600": "#ffb300",
            "700": "#ffa000",
            "800": "#ff8f00",
            "900": "#ff6f00",
            "hex": "#ffc107",
            // "a100": "#ffe57f",
            "a200": "#ffd740",
            "a400": "#ffc400",
            "a700": "#ffab00"
        },
        "orange": {
            // "50": "#fff3e0",
            // "100": "#ffe0b2",
            "200": "#ffcc80",
            "300": "#ffb74d",
            "400": "#ffa726",
            "500": "#ff9800",
            "600": "#fb8c00",
            "700": "#f57c00",
            "800": "#ef6c00",
            "900": "#e65100",
            "hex": "#ff9800",
            // "a100": "#ffd180",
            "a200": "#ffab40",
            "a400": "#ff9100",
            "a700": "#ff6d00"
        },
        "deepOrange": {
            // "50": "#fbe9e7",
            // "100": "#ffccbc",
            "200": "#ffab91",
            "300": "#ff8a65",
            "400": "#ff7043",
            "500": "#ff5722",
            "600": "#f4511e",
            "700": "#e64a19",
            "800": "#d84315",
            "900": "#bf360c",
            "hex": "#ff5722",
            "a100": "#ff9e80",
            // "a200": "#ff6e40",
            "a400": "#ff3d00",
            "a700": "#dd2c00"
        },
        "brown": {
            // "50": "#efebe9",
            // "100": "#d7ccc8",
            // "200": "#bcaaa4",
            "300": "#a1887f",
            "400": "#8d6e63",
            "500": "#795548",
            "600": "#6d4c41",
            "700": "#5d4037",
            "800": "#4e342e",
            "900": "#3e2723",
            "hex": "#795548"
        },
        "grey": {
            // "50": "#fafafa",
            // "100": "#f5f5f5",
            // "200": "#eeeeee",
            // "300": "#e0e0e0",
            "400": "#bdbdbd",
            "500": "#9e9e9e",
            "600": "#757575",
            "700": "#616161",
            "800": "#424242",
            "900": "#212121",
            "hex": "#9e9e9e"
        },
        "blueGrey": {
            // "50": "#eceff1",
            // "100": "#cfd8dc",
            // "200": "#b0bec5",
            "300": "#90a4ae",
            "400": "#78909c",
            "500": "#607d8b",
            "600": "#546e7a",
            "700": "#455a64",
            "800": "#37474f",
            "900": "#263238",
            "hex": "#607d8b"
        },
        // "black": {
        //     "hex": "#000000"
        // },
        // "white": {
        // "hex": "#ffffff"
        // }
    }
    // pick random property
    //var property = pickRandomProperty(colors);
    var colorList = colors[pickRandomProperty(colors)];
    var newColorKey = pickRandomProperty(colorList);
    var newColor = colorList[newColorKey];
    return newColor;
};
Util.getColors = function (index) {
    var colors = ColorsSet.default;
    var randomNumber = Math.floor((Math.random() * colors.length));
    return '#' + colors[randomNumber];
};

Util.getColumnsFromAliasPaths = (columnsWithoutOptions, allColumns) => {
    if (!columnsWithoutOptions || !allColumns) {
        return columnsWithoutOptions;
    }
    columnsWithoutOptions = columnsWithoutOptions.map((col) => {
        return allColumns.find((column) => {
            return column.alias_path == col.alias_path;
        })
    });

    return columnsWithoutOptions.filter(function (element) {
        return element !== undefined;
    });;
}

Util.getActiveTab = () => {
    return window.location.hash.slice(3)
        || (Util.isMainDashboard() || PACK
            ? 'dashboard-tab'
            : "list-page");
}

Util.isMainDashboard = () => window.location.pathname == baseUrl + "/home"

Util.getCurrentListId = () => {
    return Util.getActiveTab().indexOf('list-tab-') !== -1 ? Util.getActiveTab().slice('list-tab-'.length) : Util.getActiveTab()
}

Util.toggleTheme = (theme) => {
    var body = document.getElementsByTagName('body')[0];
    if (theme == currentTheme) {
        return;
    }

    body.classList.remove(currentTheme);
    currentTheme = currentTheme === 'light_theme' ? "dark_theme" : "light_theme";
    body.classList.add(currentTheme);

    Ext.Ajax.request({
        url: baseUrl + '/user/user/update-user-theme',
        method: 'GET',
        params: {
            theme: currentTheme.slice(0, currentTheme.length - 6)
        }
    });
}

Util.formatCriteriaForTree = function (criteria) {
    if (criteria.query_tree && criteria.query_tree.length > 0) {
        return criteria;
    } else {
        return {
            query_string: criteria,
            query_tree: []
        }
    }
};

Util.formatColumnOptions = function (columnOptions) {

    if (columnOptions && Util.isJson(columnOptions)) {
        columnOptions = Ext.decode(columnOptions);

        if (columnOptions.length > 0) {
            return columnOptions[0];
        }

        return columnOptions;
    } else {
        return {};
    }
};

Util.decodeOptions = function (options = '') {
    var opts = {};
    var opt = {};
    try {
        if (options && typeof options == "string") {
            opts = Ext.decode(options);
        } else if (typeof options == "object") {
            opts = options;
        }

        if(Array.isArray(opts)) {
            opt = opts.length > 0 ? opts[0] : {};
        } else if (!Array.isArray(opts) && typeof opts == "object") {
            opt = Object.keys(opts).length > 0 ? opts : {};
        }
    } catch (error) {
        return opt;
    }
    return opt;
};

let lastUniqueId = 0;
Util.getUniqueId = function (prefix = 'unique-id') {
    lastUniqueId++;
    return `${prefix}-${lastUniqueId}`;
}

Util.getContentWidth = function (elementId) {
    var html_org = $("#" + elementId).html();
    var $html_calc = $('<div>' + html_org + '</div>').css({
        position: 'absolute',
        top: -9999,
        left: -9999
    }).appendTo('body');

    var ret = {
        width: $html_calc.width(),
        height: $html_calc.height(),
    };
    $html_calc.remove();

    return ret.width;
};
Util.formatServerErrorMessages = function (messages) {
    var msg = "<div style='padding-bottom: 5px' class='error'><ul class='bullets'>";
    if (Ext.isArray(messages)) {
        for (var i = 0; i < messages.length; i++) {
            msg += "<li>" + messages[i] + "</li>";
        }
    } else {
        msg += "<li>" + messages + "</li>";
    }
    msg += "</ul></div>";

    return msg;
};

Util.deepCloneStore = function (source) {
    source = Ext.isString(source) ? Ext.data.StoreManager.lookup(source) : source;

    var target = Ext.create(source.$className, {
        model: source.model,
    });

    target.add(Ext.Array.map(source.getRange(), function (record) {
        return record.copy();
    }));

    return target;
}

Util.isElementInView = function (element, fullyInView) {
    var pageTop = $(window).scrollTop();
    var pageBottom = pageTop + $(window).height();
    var elementTop = $(element).offset().top;
    var elementBottom = elementTop + $(element).height();

    if (fullyInView === true) {
        return ((pageTop < elementTop) && (pageBottom > elementBottom));
    } else {
        return ((elementTop <= pageBottom) && (elementBottom >= pageTop));
    }
}

Util.getUniqueObjectsBy = function (arr, key) {
    return [...new Map(arr.map(item => [item[key], item])).values()]
};

export default Util;